import React, { useCallback, useEffect, useState } from 'react';

import * as merchantStorage from '../lib/storage/merchant';

type Merchant = merchantStorage.Merchant;

type MerchantContextProps = {
  // Merchant defines the user's merchant
  merchant: Merchant | null;
  // setMerchant sets a new merchant in context and stores it in local storage
  setMerchant: (merchant: Merchant) => void;
  // removeMerchant removes the merchant from context and local storage
  removeMerchant: () => void;
};

const MerchantContext = React.createContext<MerchantContextProps | null>(null);

/**
 * MerchantContextProvider provides the merchant context to it's children
 */
export function MerchantContextProvider({
  children,
}: React.PropsWithChildren<{}>) {
  const [merchant, setMerchantState] = useState(merchantStorage.get());

  // Persist the token to local storage when the token changes. Remove the token
  // if it is null.
  useEffect(() => {
    if (merchant) {
      merchantStorage.set(merchant);
    } else {
      merchantStorage.remove();
    }
  }, [merchant]);

  const removeMerchant = useCallback(() => {
    setMerchantState(null);
  }, []);

  const setMerchant = useCallback((s) => {
    setMerchantState(s);
  }, []);

  const ctx = {
    merchant,
    setMerchant,
    removeMerchant,
  };

  return (
    <MerchantContext.Provider value={ctx}>{children}</MerchantContext.Provider>
  );
}

export default MerchantContext;
